<template lang="pug">
.message-wrapper(:style="{textAlign: textAlign}")
  .message-webchat(v-if="inWebchat")
    .message-avatar(v-if="senderType === 'agents'",)
      img(v-if="avatar"
         :src="avatar" 
         :alt="avatarAltText")
      .no-image(v-else="senderInitials") {{ senderInitials }}
    template(v-if="inWebchat")
      .message-bubble-webchat-container(
        :class="{'message-customer': senderType === 'customers',\
          'message-agent': senderType === 'agents',\
          'message-system': senderType === '' }"
      )
        .message-bubble_header
            .message-bubble_date
              aiq-timeago(:since="messageDate" :maxTime="maxTime")
        .message-webchat_content(v-html="content" @click="onLink")
        .message-video_container(v-if="hasVideo")
          .message-video_content(v-for="video in videos" v-html="embedVideo(video)")
  .message-container(v-else
                    :class="{'message-customer': senderType === 'customers',\
                            'message-agent': senderType === 'agents' }")
    .message-item(v-if="senderType")
      .message-avatar
        img(v-if="avatar"
           :src="avatar" 
           :alt="avatarAltText")
        .no-image(v-else-if="!avatar && senderInitials") {{ senderInitials }}
        img(v-else 
           :src="photo"
           :alt="avatarAltText")
      aiq-dropdown(:placement="messageMenuPlacement"
                  :show-timeout="messageMenuShowTimeout"
                  class="mt-4"
                  popper-class="menu-message-popper"
                  @visible-change="handleVisibleChange")
        .message-bubble
          .message-bubble_header
            .message-bubble_name
              .message-bubble_user-name(v-if="senderType === 'agents'")
                | {{ senderName }}
              i(v-if="senderType === 'customers'",
                  :title="channelInfo.title",
                  :class="`aiq-ico-conversation-${channel}`")
              .message-bubble_user-name(v-if="senderType === 'customers'")
                | {{ customerName }}
            .message-bubble_date
              aiq-timeago(:since="messageDate" :maxTime="maxTime")
          .message-bubble_content(v-html="content" @click="onLink")
          .message-video_container(v-if="hasVideo")
            .message-video_content(v-for="video in videos" v-html="embedVideo(video)")
          slot(v-if="senderType === 'customers'", name="message-cue")
        template(v-slot:dropdown)
          aiq-dropdown-menu.message-menu
            slot(name="message-buttons")
    .message-system(v-else, v-html="content")
</template>

<script>
import get from 'lodash/get';
import moment from 'moment';
import * as log from 'loglevel';
import { url } from '../../../lib/formatters';

import BaseMessage from './BaseMessage/BaseMessage.vue';
import {
  channelsInfo, detectVideos, embedVideoHtml,
} from '../MessageUtils';

const MESSAGE_MENU_SHOW_TIMEOUT = 250;
/*
  Workaround to disable the menu when no items
  this eleme.io version do not support dropdown disabling
*/
const MESSAGE_MENU_SHOW_TIMEOUT_DISABLED = 50000;

export default {
  extends: BaseMessage,
  name: 'legacyMessage',
  props: {
    inWebchat: Boolean,
  },
  emits: ['link'],
  computed: {
    hasVideo() {
      return this.videos.length > 0;
    },
    videos() {
      if (!this.content) {
        log.warn(`Unexpected Legacy Message ${JSON.stringify(this.message)}`);
      }

      return detectVideos(this.content);
    },
    channelInfo() {
      return get(channelsInfo, get(this.message, 'payload.channel'), {
        icon: '',
        title: '',
      });
    },

    customerName() {
      return get(this, 'message.sender.profile.preferredUsername', '');
    },

    content() {
      return this.applyFilters(get(this.message, 'payload.content', ''));
    },

    hasMenuItems() {
      const messageButtons = this.$slots['message-buttons']();
      return Array.isArray(messageButtons) && messageButtons.some(x => x.key);
    },

    messageMenuShowTimeout() {
      return this.hasMenuItems ? MESSAGE_MENU_SHOW_TIMEOUT : MESSAGE_MENU_SHOW_TIMEOUT_DISABLED;
    },

    messageMenuPlacement() {
      return this.senderType === 'agents' ? 'top-start' : 'top-end';
    },
  },
  methods: {
    format(time) {
      return moment().isSame(moment(time), 'day')
        ? moment(time).calendar()
        : moment(time).format('lll');
    },
    embedVideo(video) {
      return embedVideoHtml(video, this.senderType, this.senderName);
    },
    onLink(e) {
      if (e.target.id === 'aiq-link') {
        this.$emit('link', {
          type: 'hyperlink',
          url: url(e.target.innerHTML),
        });
      }
    },
  },
};
</script>


<style lang="scss" scoped>
.mt-4 {
  margin-top: 4px;
}
</style>
